<template>
  <accordion-simple-item title="Benutzer" :flex="true" v-if="userData?.isAdmin">

      <div class="flex flex-grow flex-col gap-2 overflow-hidden h-full">
        <TRInput v-model="userSearch" type="text" placeholder="Benutzer suchen..." class="w-full"
                 data-ui="search-user-input"></TRInput>
        <button @click="navigateTo(`/administration/${accordionIndex}/creatUser` ,)"
                class="p-1 bg-white w-full hover:bg-trader-blue hover:text-white"
                data-ui="create-new-user">Benutzer Hinzufügen
        </button>
        <div class="flex flex-col gap-2  overflow-auto " data-ui="user-list">
          <div class="w-full p-1 " v-for="user in filteredUsers" :key="user.userId"
               :class="{ 'bg-trader-blue text-white': userId == user.userId, 'bg-trader-dark-gray': userId != user.userId }"
               @click="navigateTo(`/administration/${accordionIndex}/user`, { userId: user.userId })">
            <span class="w-full cursor-pointer" :data-ui="'open-username-dialog-' + user.userName">
              {{  user.userName }}</span>
          </div>
        </div>
      </div>
  </accordion-simple-item>
</template>
<script>
import TRInput from "@/components/Base/v2/TRInput.vue";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";

export default {
  name: "SUser",
  data() {
    return {
      userSearch: "",
      usersData: {
        users: [],
      },
      userId: 0,
    }
  },
  props:{
    accordionIndex: {
      type: Number,
      default: 0
    },
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredUsers() {
      return this.usersData.users.filter(user => user.userName.toLowerCase().includes(this.userSearch.toLowerCase()));
    },
  },
  methods: {
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
    },
    async getAllUser() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query GetAllUser {
              getAllUser {
                userId
                userName
              }
            }
          `
        });
        this.usersData.users = response.data.getAllUser;
      } catch (error) {
        console.error("Fehler beim Abrufen der getAllUser:", error);
      }
    },
  },
  mounted() {
    this.getAllUser()
  },
  created() {
    this.userId =  this.$route.params.userId
  },
  watch: {
    '$route.params.userId': function (newId, oldId) {
      this.userId = newId;
     this.getAllUser();
    },
  },
}
</script>